import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ASSIGN_USER_ROLE: (userId, role) => ({ userId, role }),
    API: {
      ASSIGN_USER_ROLE: apiResourceActionCreator('user/role')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/user/role`, authToken, payload, actions.admin.api.assignUserRole);

function* assignUserRole(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'assignUserRole',
  action: actions,
  sagas: assignUserRole,
  reducers: {
    request: (state, action) => ({
      ...state,
      isAssigningUserRole: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isAssigningUserRole: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isAssigningUserRole: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/assignUserRole.js